import { render, staticRenderFns } from "./home-menu.vue?vue&type=template&id=29806fdb&scoped=true&"
import script from "./home-menu.component.ts?vue&type=script&lang=ts&"
export * from "./home-menu.component.ts?vue&type=script&lang=ts&"
import style0 from "./home-menu.vue?vue&type=style&index=0&id=29806fdb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29806fdb",
  null
  
)

export default component.exports